/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIconFill from '../../extendIconFill';

const Signal3 = props => (
  <svg width="22" height="13" viewBox="0 0 22 13" {...props}>
    <rect y="9" width="4" height="4" />
    <rect x="6" y="6" width="4" height="7" />
    <rect x="12" y="3" width="4" height="10" />
    <rect x="18" width="4" height="13" fill="#CCCCCC" />
  </svg>
);

export default extendIconFill(Signal3);
